/**
 * Class for promise queue
 */
class Queue {
    /**
     * Constructor
     * @param {number} maxParallell
     * @param {Function} taskProcessedCallback
     * @param {Function} taskErrorCallback
     */
    constructor(maxParallell, taskProcessedCallback, taskErrorCallback) {
        this.maxParallell = maxParallell;
        this.taskProcessedCallback = taskProcessedCallback;
        this.taskErrorCallback = taskErrorCallback;

        this.queue = [];
        this.currentlyProcessing = new Set();
        this.paused = false;
    }

    /**
     * Add task to queue
     * @param {Object} uploadFileTask - Task to be added to queue
     * @param {string} uploadFileTask.id - Id of a file
     * @param {Promise} uploadFileTask.promise - Promise to upload a file
     * @param {boolean} highPriority - If file is high priority (put it in a top of queue)
     */
    addTask(uploadFileTask, highPriority = false) {
        // Add task to queue, position based on highPriority
        if (highPriority) {
            this.queue.unshift(uploadFileTask);
        } else {
            this.queue.push(uploadFileTask);
        }

        // Trigger process queue method
        this._processQueue();
    }

    /**
     * Prioritize (move up in a queue) the task
     * @param {string} uploadFileTaskId - Id of a file
     */
    prioritizeTask(uploadFileTaskId) {
        const fileIndex = this.queue.findIndex(file => file.id === uploadFileTaskId);

        if (fileIndex === -1) {
            return;
        }

        const deletedFileArray = this.queue.splice(fileIndex, 1);

        this.queue.unshift(deletedFileArray[0]);
    }

    /**
     * Toggle pause state
     */
    togglePause() {
        this.paused = !this.paused;
        if (!this.paused) {
            this._processQueue();
        }
    }

    /**
     * Process queue
     * @private
     */
    _processQueue() {
        while (
            this.maxParallell - this.currentlyProcessing.size > 0 &&
            this.queue.length > 0 &&
            !this.paused
        ) {
            // Get next task and push it to currentlyProcessing tasks array
            let task = this.queue.shift();
            this.currentlyProcessing.add(task);
            
            task.setProcessed();
            // Try to resolve task promise
            task.promise()
                .then(data => {
                    // Notify outsiders that the task has been done
                    this.taskProcessedCallback({ id: task.id, data: data });
                })
                .catch(error => {
                    this.taskErrorCallback({ id: task.id, error: error });
                })
                .finally(() => {
                    // Remove from currentlyProcessing
                    this.currentlyProcessing.delete(task);

                    // Process queue some more
                    this._processQueue();
                });
        }
    }
}

module.exports = Queue;
